module.exports = __webpack_public_path__ + "static/img/finance2.a8e6b962.png";